import React from 'react';
import Icon, { ICONS } from './icons';

interface AudioWaveformPlaceholderProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export default function AudioWaveformPlaceholder({
  size = 'medium',
  className = ''
}: AudioWaveformPlaceholderProps) {
  const iconSize = size === 'small' ? 20 : size === 'large' ? 48 : 32;
  const barCount = size === 'small' ? 5 : size === 'large' ? 12 : 8;
  const barWidth = size === 'small' ? 2 : 3;
  const maxBarHeight = size === 'small' ? 16 : size === 'large' ? 40 : 24;

  // Static bar heights for visual waveform effect
  const barHeights = [0.4, 0.7, 0.5, 0.85, 0.6, 0.9, 0.45, 0.75, 0.55, 0.8, 0.65, 0.7];

  return (
    <div className={`flex flex-col items-center justify-center gap-2 ${className}`}>
      <Icon name={ICONS.AUDIO} size={iconSize} className="text-purple-400" />

      <div className="flex items-center justify-center gap-0.5">
        {Array.from({ length: barCount }).map((_, i) => (
          <div
            key={i}
            className="bg-purple-500/60 rounded-full"
            style={{
              width: barWidth,
              height: Math.round(barHeights[i % barHeights.length] * maxBarHeight)
            }}
          />
        ))}
      </div>
    </div>
  );
}
